import { Star, Users, Eye, ChevronDown } from 'lucide-react';

export const ProductHeader = ({
  product,
  companyState,
  isExpanded,
  setIsExpanded,
  selectedSlots,
  formatSelectedTimeRange,
  setShowProductInfo
}) => {
  return (
    <div
      className="p-4 sm:p-5 cursor-pointer hover:bg-slate-50 transition-colors duration-200"
      onClick={() => setIsExpanded(!isExpanded)}
    >
      {/* ── Mobile layout ── */}
      <div className="flex sm:hidden items-start justify-between gap-3">
        <div className="flex flex-col gap-2 min-w-0 flex-1">
          {/* Category + price row */}
          <div className="flex items-center gap-2 flex-wrap">
            <span className="px-2.5 py-0.5 bg-slate-100 rounded-full text-xs font-bold text-slate-800 whitespace-nowrap">
              {product.category?.name || 'Premium'}
            </span>
            <span className="text-slate-300">•</span>
            <div className="flex items-center gap-1">
              <Star className="w-3.5 h-3.5 text-yellow-500 fill-yellow-500 shrink-0" />
              <span className="text-base font-bold text-slate-900">
                {companyState?.operatingLocation?.code === 'US' ? '$' : '₹'}
                {parseFloat(product.price?.priceAmt || '0').toFixed(2)}
                <span className="text-xs font-normal text-slate-500">/hr</span>
              </span>
            </div>
          </div>

          {/* Capacity */}
          {product.capacity && (
            <div className="flex items-center gap-1 text-slate-600">
              <Users className="w-3.5 h-3.5 shrink-0" />
              <span className="text-xs font-medium">
                Up to {product.capacity} {product.capacity === 1 ? 'person' : 'people'}
              </span>
            </div>
          )}

          {/* Selected time badge */}
          {selectedSlots.length > 0 && (
            <div className="inline-flex px-3 py-2 rounded-lg bg-blue-500 text-white self-start">
              <div className="text-xs font-medium opacity-90 mr-1">Selected:</div>
              <div className="text-xs font-bold">{formatSelectedTimeRange()}</div>
            </div>
          )}
        </div>

        {/* Right: detail button + chevron */}
        <div className="flex items-center gap-2 shrink-0">
          <button
            onClick={(e) => { e.stopPropagation(); setShowProductInfo(true); }}
            className="flex items-center gap-1 px-2.5 py-1.5 bg-blue-50 hover:bg-blue-100 text-blue-700 rounded-lg transition-colors"
            title="View space details"
          >
            <Eye className="w-3.5 h-3.5" />
            <span className="text-xs font-medium">Details</span>
          </button>
          <div className="w-8 h-8 rounded-full bg-slate-100 flex items-center justify-center hover:bg-slate-200 transition-colors shrink-0">
            <ChevronDown className={`w-4 h-4 text-slate-700 transition-transform duration-300 ${isExpanded ? 'rotate-180' : ''}`} />
          </div>
        </div>
      </div>

      {/* ── Desktop layout: original ── */}
      <div className="hidden sm:flex items-center justify-between">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-3 lg:gap-4 flex-wrap">
            <span className="px-3 py-1 bg-slate-100 rounded-full text-sm font-bold text-slate-800 whitespace-nowrap">
              {product.category?.name || 'Premium'}
            </span>

            <span className="text-slate-300">•</span>

            <div className="flex items-center gap-2">
              <Star className="w-4 h-4 text-yellow-500 fill-yellow-500 shrink-0" />
              <span className="text-lg font-bold text-slate-900">
                {companyState?.operatingLocation?.code === 'US' ? '$' : '₹'}
                {parseFloat(product.price?.priceAmt || '0').toFixed(2)}
                <span className="text-sm font-normal text-slate-500">/hr</span>
              </span>
            </div>

            <span className="text-slate-300">•</span>

            {product.capacity && (
              <div className="flex items-center gap-1 text-slate-600">
                <Users className="w-4 h-4 shrink-0" />
                <span className="text-sm font-medium">
                  Up to {product.capacity} {product.capacity === 1 ? 'person' : 'people'}
                </span>
              </div>
            )}
          </div>
        </div>

        <div className="flex items-center gap-3 lg:gap-4 shrink-0">
          {selectedSlots.length > 0 && (
            <div className="px-4 lg:px-5 py-2.5 lg:py-3 rounded-lg shadow-md bg-blue-500 text-white">
              <div className="text-xs font-medium mb-1 opacity-90">Selected Time</div>
              <div className="text-sm font-bold">{formatSelectedTimeRange()}</div>
            </div>
          )}

          <button
            onClick={(e) => { e.stopPropagation(); setShowProductInfo(true); }}
            className="flex items-center gap-1.5 px-3 py-1.5 bg-blue-50 hover:bg-blue-100 text-blue-700 rounded-lg transition-colors group"
            title="View space details"
          >
            <Eye className="w-4 h-4 group-hover:scale-110 transition-transform" />
            <span className="text-xs font-medium">Full Details</span>
          </button>

          <div className="w-10 h-10 rounded-full bg-slate-100 flex items-center justify-center hover:bg-slate-200 transition-colors">
            <ChevronDown className={`w-5 h-5 text-slate-700 transition-transform duration-300 ${isExpanded ? 'rotate-180' : ''}`} />
          </div>
        </div>
      </div>
    </div>
  );
};